import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface TaxonomyCategoriesRequest extends ApiParameter {
    maxDepth?: number;
    startCategoryId?: string;
    includeStartCategory?: boolean;
    onSuccess?: (result: TaxonomyCategoriesResponse) => void;
}

export interface Category {
    id: string;
    name: string;
    hasSubCategories?: boolean;
    children?: Category[];
    // Add other properties as needed
}

export interface TaxonomyCategoriesResponse {
    categories: Category[];
    // Or if it's directly an array: Category[];
}

const categoriesUrl = "/api/v1/categories/";

export function getTaxonomyCategories(parameter?: TaxonomyCategoriesRequest) {
    return get<TaxonomyCategoriesResponse>(categoriesUrl, parameter);
}


